import classNames from 'classnames';

import { type ConnectorField, ConnectorFieldFormItem, getConnectorFieldPlaceholder } from '@/entities/connector';

import styles from './ConfigFieldSection.module.css';

type ConfigFieldSectionProps = {
  schemaFields: readonly ConnectorField[];
  disabled?: boolean;
  showConfigJson?: boolean;
};

export const ConfigFieldSection = ({
  schemaFields,
  disabled = false,
  showConfigJson = false,
}: ConfigFieldSectionProps) => {
  return (
    <section className={classNames(styles.wrapper, showConfigJson ? styles.hidden : undefined)}>
      {schemaFields.map((field) => (
        <ConnectorFieldFormItem
          key={field.label}
          field={field}
          disabled={disabled}
          className={styles.panelField}
          placeholder={getConnectorFieldPlaceholder(field)}
          inputClassName={
            field.inputType === 'number'
              ? styles.numberInput
              : field.inputType === 'textarea'
                ? styles.textarea
                : styles.textInput
          }
        />
      ))}
    </section>
  );
};
